module.exports = __webpack_public_path__ + "img/product_icon_vca_2.87d2d743.png";